import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import {
  apiActions as commonApiActions,
  apiResourceActionCreator,
  endpointQuery
} from '../../common';
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const actions = createActions({
  TASK: {
    GET_TEAM_TASKS: (businessId, businessTeamId, filter) => ({
      businessId,
      businessTeamId,
      filter
    }),
    API: {
      GET_TEAM_TASKS: apiResourceActionCreator('teamTasks')
    }
  }
});

export const apiAction = (authToken, payload) =>
  commonApiActions.authenticated.get(
    `${API_ENDPOINT}/team-tasks/${payload.businessId}/${payload.businessTeamId}${endpointQuery(payload.query)}`,
    authToken,
    actions.task.api.getTeamTasks
  );

function* getTeamTasks(action) {
  const authToken = yield select(authTokenSelector);

  yield put(apiAction(authToken, action.payload));
}

const configuration = {
  name: 'getTeamTasks',
  action: actions,
  sagas: getTeamTasks,
  reducers: {
    request: (state) => ({
      ...state,
      isFetching: true
    }),
    success: (state, action) => {
      const payloadData = action.payload.teamTasks;
      const hasTasks = payloadData && payloadData.tasks;
      return {
        ...state,
        teamTasks: hasTasks ? payloadData.tasks : payloadData,
        skippedTeamTaskUserReassessment: Boolean(
          payloadData && payloadData.skippedTaskUserReassessment
        ),
        isFetching: false
      };
    },
    failed: (state) => ({
      ...state,
      isFetching: false
    })
  }
};

export default configuration;



// WEBPACK FOOTER //
// ./src/state/modules/task/configurations/getTeamTasks.js